export default class Map {
    constructor(element) {
        this.map = element
        this.initMap()
    }

    initMap() {
        const position = {lat: 51.214576, lng: 4.4114197}
        const icon = {
            url: TEMPLATE_PATH + "/assets/images/map_marker.png",
            scaledSize: new google.maps.Size(51, 66)
        };

        this.google_map = new google.maps.Map(this.map, {
            center: position,
            zoom: 19,
            styles: [{
                "stylers": [{
                    "saturation": -100
                }]
            }],
        });

        const marker = new google.maps.Marker({
            position: position,
            map: this.google_map,
            icon: icon,
        })
    }
}
